const TYPE = "usuario";

const usuarioModule = {
  find: async (dbConnection) => {
    let usuario = null;
    let idUsuario = localStorage.getItem('idUsuario');
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        _id: { $eq: idUsuario }
      },
      limit: 1
    });

    if (result.docs.length) {
      usuario = result.docs[0];
    }
    
    return usuario;
  },
};

export default usuarioModule;
